import { NoData, RenderWhen } from "@components";
import RLCard from "@components/card/RLCard";
import {
  ClassificationReason,
  ClassificationReasonIcon
} from "@components/classification-reason";
import styles from "@modules/network/components/header/header.module.scss";
import { ThreatIntelReasonEnum } from "@modules/network/enums";
import { UrlThreatIntelReason } from "@modules/network/mappings";

type Props = {
  classification?: string;
  reason?: ThreatIntelReasonEnum;
};

const ClassificationReasonCard = ({ classification, reason }: Props) => (
  <RLCard
    className={styles.header_card}
    header={
      <RLCard.Header className={styles.card_title}>
        Classification Reason
      </RLCard.Header>
    }
    content={
      <RLCard.Content className="p-0 flex align-items-center justify-content-center">
        <ClassificationReason
          icon={
            <RenderWhen condition={classification !== "unknown"}>
              <ClassificationReasonIcon source={-1} style={reason} />
            </RenderWhen>
          }
          title={
            classification ? (
              <UrlThreatIntelReason reason={reason} />
            ) : (
              <NoData />
            )
          }
        />
      </RLCard.Content>
    }
  />
);

export default ClassificationReasonCard;
